import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminNavBar from '../../components/UI/AdminNavBar';
import Footer from '../../components/UI/Footer';
import { getFromLocalStorage, deleteFromLocalStorage } from '../../store';

const WTTEventFinder = () => {
  const [date, setDate] = useState('');
  const [excludeEvent, setExcludeEvent] = useState('');
  const [truck, setTruck] = useState('');
  const [result, setResult] = useState('');
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isSuperAdminLoggedIn, setIsSuperAdminLoggedIn] = useState(getFromLocalStorage("isSuperAdminLoggedIn") || "false");
  const [isAccountantLoggedIn, setIsAccountantLoggedIn] = useState(getFromLocalStorage("isAccountantLoggedIn") || "false");
  const [isStockAdminLoggedIn, setIsStockAdminLoggedIn] = useState(getFromLocalStorage("isStockAdminLoggedIn") || "false");
  const [isEventCoordinatorLoggedIn, setIsEventCoordinatorLoggedIn] = useState(getFromLocalStorage("isEventCoordinatorLoggedIn") || "false");

  useEffect(() => {
    if (isSuperAdminLoggedIn !== "true" && isEventCoordinatorLoggedIn !== "true") {
      window.location.href = "/admin";
    } else {
      const params = new URLSearchParams(window.location.search);
      const dateParam = params.get('date') || '';
      const excludeEventParam = params.get('exclude_event') || '';
      const truckParam = params.get('truck') || '';

      setDate(decodeURIComponent(dateParam));
      setExcludeEvent(decodeURIComponent(excludeEventParam));
      setTruck(decodeURIComponent(truckParam));
    }
  }, [isSuperAdminLoggedIn, isEventCoordinatorLoggedIn]);

  const logout = () => {
    deleteFromLocalStorage("isSuperAdminLoggedIn");
    deleteFromLocalStorage("isEventCoordinatorLoggedIn");
    deleteFromLocalStorage("isAccountantLoggedIn");
    deleteFromLocalStorage("isStockAdminLoggedIn");
    setIsSuperAdminLoggedIn("false");
    setIsEventCoordinatorLoggedIn("false");
    setIsAccountantLoggedIn("false");
    setIsStockAdminLoggedIn("false");
    window.location.reload();
  };

  const handleFindEvents = async () => {
    const api = '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'
    setLoading(true);
    setResult('');
    setSections([]);
    try {
      const prompt = `
      List all major public events happening in Melbourne during the week starting ${date} where food trucks, food vendors, or stall holders could be involved.

      Strictly include only events that are confirmed to occur within that exact week in 2025. Do not include events that occur at other times of the year, even if they are popular.

      Exclude any mention of the event named "${excludeEvent}" and truck "${truck}".

      Include a mix of the following types of events, and label each category separately:
      - Music festivals and concerts
      - Public festivals (e.g., cultural, food, arts)
      - Large city council events or community celebrations
      - University or student campus events open to the public
      - Sports events with large public attendance
      - Major markets or farmers markets that typically have food trucks, food vendors, or stall holders

      When selecting events, specifically check for and prioritize events that have known food truck, food vendor, or stall holder involvement, or have opened Expressions of Interest (EOIs). Only include events that actively accept or feature these types of vendors.

      For each event, also include the following vendor-related information if available:
      - Vendor application (EOI) opening date
      - Vendor application (EOI) closing date
      - Expected attendance or estimated crowd size
      - Typical vendor fees or costs
      - Any other important vendor-specific details (e.g., power availability, required certifications)
      - Event organiser email address
      - Event organiser phone number

      If you are not 100% certain an event happens in that exact week, do not include it.

      List **at least 5 events per category**. If there are fewer than 5 events actually happening in a category that week, list as many as possible and then write "None" for the remaining slots to ensure there are always 5 lines per category.

      Provide the output as clearly labeled plain text lists, each category labeled separately exactly as below:
      ...
      `;

      // const api = 'YOUR_API_KEY_HERE'; // Replace with your actual key

      const response = await axios.post(
        'https://api.openai.com/v1/chat/completions',
        {
          model: 'gpt-4o',
          messages: [
            {
              role: 'system',
              content: 'You are a helpful assistant who only outputs a list of events clearly without percentages or commentary.'
            },
            {
              role: 'user',
              content: prompt.trim()
            }
          ],
          temperature: 1,
          max_tokens: 1000
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${api}`
          }
        }
      );

      const text = response.data.choices[0].message.content;
      setResult(text);

      const parsedSections = text.split('\n\n');
      setSections(parsedSections);
    } catch (error) {
      console.error(error);
      setResult('Failed to fetch events.');
    } finally {
      setLoading(false);
    }
  };

  const EventCard = ({ title, details }) => (
    <div
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        background: '#ffffff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
      }}
    >
      <h4
        style={{
          marginTop: 0,
          marginBottom: '12px',
          fontSize: '18px',
          color: '#2959a5',
        }}
      >
        {title}
      </h4>
      <div
        style={{
          fontSize: '15px',
          lineHeight: '1.6',
          color: '#333',
          whiteSpace: 'pre-line',
        }}
      >
        {details}
      </div>
    </div>
  );
  
  

  return (
    <div className="admin-layout">
      <AdminNavBar
        isSuperAdminLoggedIn={isSuperAdminLoggedIn}
        isEventCoordinatorLoggedIn={isEventCoordinatorLoggedIn}
        isAccountantLoggedIn={isAccountantLoggedIn}
        isStockAdminLoggedIn={isStockAdminLoggedIn}
        logout={logout}
      />

      <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif' }}>
        <h2>Melbourne Event Finder</h2>

        <div style={{ marginBottom: '10px' }}>
          <label>Date (e.g., 08 Oct 2024):</label>
          <input
            type="text"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={{ width: '100%', padding: '8px', marginTop: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label>Exclude Event:</label>
          <input
            type="text"
            value={excludeEvent}
            onChange={(e) => setExcludeEvent(e.target.value)}
            style={{ width: '100%', padding: '8px', marginTop: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label>Truck Name:</label>
          <input
            type="text"
            value={truck}
            onChange={(e) => setTruck(e.target.value)}
            style={{ width: '100%', padding: '8px', marginTop: '4px' }}
          />
        </div>

        <button
          onClick={handleFindEvents}
          disabled={loading}
          style={{
            padding: '10px 20px',
            marginTop: '10px',
            backgroundColor: '#2959a5',
            color: '#ffffff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          {loading ? 'Finding...' : 'Find Events'}
        </button>

        <div
  style={{
    backgroundColor: '#f5f7fa', // Light subtle background to break up white
    padding: '40px 20px',       // More top/bottom breathing room
    borderRadius: '12px',
    marginTop: '30px',
    marginBottom: '50px',
  }}
>
  {sections.map((section, idx) => {
    const [categoryLine, ...events] = section.split('\n- ').map(line => line.trim());
    const categoryTitle = categoryLine.replace(':', '');

    return (
      <div key={idx} style={{ marginBottom: '40px' }}>
        <h3
          style={{
            borderBottom: '2px solid #2959a5',
            paddingBottom: '6px',
            marginBottom: '20px',
            fontSize: '20px',
            color: '#222',
          }}
        >
          {categoryTitle}
        </h3>
        {events.map((eventText, i) => (
          <EventCard key={i} title={`Event ${i + 1}`} details={eventText} />
        ))}
      </div>
    );
  })}
</div>

      </div>

      <Footer />
    </div>
  );
};

export default WTTEventFinder;
